import React, {useState, useEffect} from 'react';
import {loadStripe} from '@stripe/stripe-js';
import {Elements, useStripe} from '@stripe/react-stripe-js';
import { ajax_wrapper } from 'functions';

// Initialize with null, will be set after fetching from backend
let stripePromise = null;

const Wrapper = (props) => {
  const [loaded, setLoaded] = useState(false);
  
  useEffect(() => {
    // Load the publishable key from the backend
    ajax_wrapper('GET', '/api/stripe_publishable_key/', {}, (data) => {
      stripePromise = loadStripe(data.publishable_key);
      setLoaded(true);
    });
  }, []);
  
  if (!loaded) return <div>Loading payment system...</div>;
  
  return (
    <Elements stripe={stripePromise}>
      <PaymentStatus {...props} />
    </Elements>
  );
};

const PaymentStatus = () => {
  const stripe = useStripe();
  const [message, setMessage] = useState(null);

  useEffect(() => {
    if (!stripe) {
      return;
    }

    // Retrieve the "payment_intent_client_secret" query parameter appended to
    // your return_url by Stripe.js
    const clientSecret = new URLSearchParams(window.location.search).get(
      'payment_intent_client_secret'
    );

    // Retrieve the PaymentIntent
    stripe
      .retrievePaymentIntent(clientSecret)
      .then(({paymentIntent}) => {
        // Inspect the PaymentIntent `status` to indicate the status of the payment
        // to your customer.
        //
        // Some payment methods will [immediately succeed or fail][0] upon
        // confirmation, while others will first enter a `processing` state.
        //
        // [0]: https://stripe.com/docs/payments/payment-methods#payment-notification
        switch (paymentIntent.status) {
          case 'succeeded':
            setMessage('Success! Payment received.');
            break;

          case 'processing':
            setMessage("Payment processing. We'll update you when payment is received.");
            break;

          case 'requires_payment_method':
            // Redirect your user back to your payment page to attempt collecting
            // payment again
            setMessage('Payment failed. Please try another payment method.');
            break;

          default:
            setMessage('Something went wrong.');
            break;
        }
      });
  }, [stripe]);


  return message;
};

export default Wrapper;